import { useState } from "react";
import logo from "../assets/teddys_tallow_logo.png";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="bg-white border-b relative z-50">
      <div className="max-w-6xl mx-auto px-6 md:px-8 flex justify-between items-center h-32">
        {/* Logo */}
        <a href="/" className="flex items-center">
          <img
            src={logo}
            alt="Teddy’s Tallow"
            className="h-20 sm:h-24 md:h-28 w-auto"
          />
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-6 text-sm md:text-base font-medium">
          <a href="#mission" className="hover:underline">Mission</a>
          <a href="#products" className="hover:underline">Products</a>
          <a href="#about" className="hover:underline">About</a>
          <a href="#media" className="hover:underline">Media</a>

          {/* Divider */}
          <span className="w-px h-6 bg-gray-300 mx-2" />

          {/* Shop Buttons */}
          <a
            href="https://teddystallowchips.com"
            className="px-5 py-2 border border-black rounded-full hover:bg-black hover:text-white transition"
          >
            Shop Chips
          </a>
          <a
            href="https://teddystallowbalm.com"
            className="px-5 py-2 bg-black text-white rounded-full hover:opacity-90 transition"
          >
            Shop Balm
          </a>
        </nav>

        {/* Mobile Hamburger Button */}
        <div className="md:hidden">
          <button
            onClick={() => setIsOpen(true)}
            className="p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-300"
          >
            <Bars3Icon className="h-8 w-8 text-gray-800" />
          </button>
        </div>
      </div>

      {/* Fullscreen Mobile Menu (Animated) */}
      <div
        className={`fixed inset-0 bg-white flex flex-col justify-center items-center md:hidden z-50
          transition-all duration-300 ease-out
          ${isOpen ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 -translate-y-4 pointer-events-none"}
        `}
      >
        {/* Close button */}
        <button
          onClick={() => setIsOpen(false)}
          className="absolute top-6 right-6 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-300"
        >
          <XMarkIcon className="h-10 w-10 text-gray-800" />
        </button>

        {/* Navigation Links */}
        <div
          className={`flex flex-col items-center space-y-8 text-2xl font-medium mb-12
            transition-all duration-300 delay-75
            ${isOpen ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"}
          `}
        >
          <a href="#mission" onClick={() => setIsOpen(false)}>Mission</a>
          <a href="#products" onClick={() => setIsOpen(false)}>Products</a>
          <a href="#about" onClick={() => setIsOpen(false)}>About</a>
          <a href="#media" onClick={() => setIsOpen(false)}>Media</a>
          <a href="#blog" onClick={() => setIsOpen(false)}>Blog</a>
        </div>

        {/* Mobile Shop CTAs */}
        <div
          className={`flex flex-col space-y-4 w-full px-10
            transition-all duration-300 delay-150
            ${isOpen ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"}
          `}
        >
          <a
            href="https://teddystallowchips.com"
            className="w-full text-center py-4 border border-black rounded-full text-lg font-medium"
          >
            Shop Chips
          </a>
          <a
            href="https://teddystallowbalm.com"
            className="w-full text-center py-4 bg-black text-white rounded-full text-lg font-medium"
          >
            Shop Balm
          </a>
        </div>
      </div>
    </header>
  );
}
